import { OrderMeasuresTypes } from '../enums';

export interface IOrderItemProduct {
    name: string;
    code: string;
}

export interface ICreateOrderItemDto {
    product: IOrderItemProduct;
    quantity?: number;
    weight?: number;
}

export interface ICreateOrderMeasureDto {
    type: OrderMeasuresTypes;
    value: number;
}

export interface ICreateOrderDto {
    scheduledDate: string;
    trip: string;
    checkpointIndex: number;
    code: string;
    qtn: string;
    orderItems: ICreateOrderItemDto[];
    orderMeasures: ICreateOrderMeasureDto[];
    pinRequired?: boolean;
    organizationId: string;
}
